<template>
  <div class="edit-event-dialog">
    <v-dialog v-model="open" width="400">
      <v-card class="event-form">
        <v-card-title class="p-3" color="primary">
          <v-icon class="mr-3" @click="close">
            mdi-close
          </v-icon>

           {{ event.isRecurring? $t('DuplicateEvent.DuplicateEventSeries') : $t('DuplicateEvent.DuplicateEvent') }} 
        </v-card-title>

        <validation-observer ref="form" v-slot="{ invalid }">
          <v-form class="d-flex flex-column p-4" @submit.prevent="onSubmit">
            <validation-provider v-slot="{ errors }" name="EventName" rules="required|max:125">
              <v-text-field v-model="event.name" :counter="125" :error-messages="errors"
              :label="$t('NewCalendarItem.EventName')+'*'"
              >
              </v-text-field>
            </validation-provider>

            <v-card-actions class="pt-4 pb-4 d-flex align-items-center justify-content-between">
              <v-btn class="btn-cancel" @click="cancel">
                {{$t('GeneralTranslations.Cancel') }}
              </v-btn>
              <v-btn class="btn-default" type="submit" :disabled="invalid">
                {{$t('GeneralTranslations.Ok') }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </validation-observer>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import "@/plugins/vee-validate";

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    event: {
      type: Object,
      default: () => ({name:''})
    },
    duplicatedEventId: {
      type: String,
      default: ''
    },
    value: Boolean
  },
  data() {
    return {
      loading: false,
    };
  },

  computed: {
    open: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },

  methods: {
    close() {
      this.open = false
    },
    cancel(){
      this.$router.push('/calendar/' + this.duplicatedEventId);
    },
    onSubmit() {
      this.close()
    }
  }
};
</script>

<style>
</style>
